export default {
  delete_success: 'A oferta foi eliminada com sucesso',
  delete_failed: 'A eliminação da oferta falhou',
  delete_confirm_title: 'Tem a certeza de que pretende eliminar esta oferta?',
  delete_last_day_confirm_title: 'Remover o último dia restante irá eliminar esta oferta. Tem a certeza?',
  confirm: 'Confirmar',
  cancel: 'Cancelar',
  qualifying_items: 'Itens elegíveis',
  free_items: 'Itens gratuitos',
  all_day: 'Todo o dia',
  starts_on: 'Começa em {{date}}',
  ends_on: 'Termina em {{date}}',
  ends_when_deleted: 'Termina quando eliminada',
  off: '{{amount}} de desconto',
  min_spend_value: 'Gasto mínimo: {{amount}}',
};
